import { createContext, useContext } from 'react'
import type { ReactNode } from 'react'

/**
 * Lets a tile stop the extra camera it is showing.
 *
 * A context rather than a prop because `VideoTile` is rendered from 22 call
 * sites across 8 layout components, none of which otherwise care that extra
 * cameras exist — threading a callback through all of them would spread the
 * feature across every layout to serve one button.
 *
 * Null outside a meeting (standalone/preview renders), in which case the tile
 * simply doesn't offer the control.
 */
const VideoInputContext = createContext<((sourceId: string) => void) | null>(null)

export function VideoInputProvider({
  onRemoveVideoInput,
  children,
}: {
  onRemoveVideoInput?: (sourceId: string) => void
  children: ReactNode
}) {
  return (
    <VideoInputContext.Provider value={onRemoveVideoInput ?? null}>
      {children}
    </VideoInputContext.Provider>
  )
}

/** Returns the remover, or null when there is nothing to remove into. */
export function useRemoveVideoInput() {
  return useContext(VideoInputContext)
}
